import { useContext, useEffect, useState } from 'react';
import './WatchesSubcats.css';
import { ConfigContext } from '../../../assets/contexts/configContext';
import mainApi from '../../../assets/api/MainApi';
import { AUDEMARS_CATEGORY_LINK, BIRKIN_CATEGORY_LINK, BOLIDE_A_BRAC_CATEGORY_LINK, BRIDE_A_BRAC_CATEGORY_LINK, BVLGARY_CATEGORY_LINK, CARTIER_CATEGORY_LINK, CATALOG_MAIN_LINK, CONSTANCE_CATEGORY_LINK, EVELYNE_TPM_CATEGORY_LINK, FINE_ART_CATEGORY_LINK, FP_JOURNE_CATEGORY_LINK, FRANK_MULLER_CATEGORY_LINK, HAC_A_DOS_CATEGORY_LINK, HERBAG_ZIP_CATEGORY_LINK, HERMES_BAGS_CATEGORY_LINK, HUBLOT_CATEGORY_LINK, IMG_PLACEHOLDER_PRODUCT, JEWELRY_CATEGORY_LINK, KELLY_CATEGORY_LINK, PATEK_PHILIPPE_CATEGORY_LINK, PICOTIN_LOCK_CATEGORY_LINK, RICHARD_MILE_CATEGORY_LINK, ROLEX_CATEGORY_LINK, WATCHES_CATEGORY_LINK } from "../../../assets/utils/constants";
import CategoryCard from '../../Catalog/CategoryCard/CategoryCard';
import MiniPreloader from '../../MiniPreloader/MiniPreloader';
import { Link } from 'react-router-dom';

const WATCHES_CATEGORY_ID = "676479d4c86afd6a2d54e4b4"


const DESIRED_CATALOG_ZERO_LEVEL_ORDER = [
    WATCHES_CATEGORY_LINK,
    JEWELRY_CATEGORY_LINK,
    HERMES_BAGS_CATEGORY_LINK,
    FINE_ART_CATEGORY_LINK,
];

const DESIRED_CATALOG_WATCHES_ORDER = [
    ROLEX_CATEGORY_LINK,
    AUDEMARS_CATEGORY_LINK,
    PATEK_PHILIPPE_CATEGORY_LINK,
    RICHARD_MILE_CATEGORY_LINK,
    CARTIER_CATEGORY_LINK,
    BVLGARY_CATEGORY_LINK,
    FRANK_MULLER_CATEGORY_LINK,
    HUBLOT_CATEGORY_LINK,
    FP_JOURNE_CATEGORY_LINK,
    BIRKIN_CATEGORY_LINK,
    KELLY_CATEGORY_LINK,
    CONSTANCE_CATEGORY_LINK,
    HERBAG_ZIP_CATEGORY_LINK,
    EVELYNE_TPM_CATEGORY_LINK,
    HAC_A_DOS_CATEGORY_LINK,
    PICOTIN_LOCK_CATEGORY_LINK,
    BRIDE_A_BRAC_CATEGORY_LINK,
    BOLIDE_A_BRAC_CATEGORY_LINK,
];

function WatchesSubcats() {
    const [brands, setBrands] = useState(null)
    const [preloaders, setPreloaders] = useState({
        getBrands: true
    })
    const config = useContext(ConfigContext)
    const { cardTokens, initialConstants } = config
    const { SHOP_ID_FOR_API } = initialConstants

    useEffect(() => {
        mainApi
            .getCategories({
                limit: 25,
                shop_id: SHOP_ID_FOR_API,
                _id: WATCHES_CATEGORY_ID,
            })
            .then((res) => {
                console.log(res.data)
                setBrands(res.data)
            })
            .catch((err) => {
                console.log(err);
            })
            .finally(() => {
                setPreloaders(prevValue => ({
                    ...prevValue,
                    getBrands: false,
                }));
            });
    }, [])
    return (
        <div className='watches-subcats'>
                {!preloaders.subcategories ?
                    brands && brands.length > 0 ?
                        <div className="watches-subcats__items">
                            {brands
                                .sort((a, b) => {
                                    return (
                                        DESIRED_CATALOG_WATCHES_ORDER.indexOf(a.translit_name) -
                                        DESIRED_CATALOG_WATCHES_ORDER.indexOf(b.translit_name)
                                    );
                                })
                                .map((cat, i) => (
                                    <Link
                                        className="watches-subcats__item"
                                        to={`${CATALOG_MAIN_LINK}/${WATCHES_CATEGORY_LINK}/${cat.translit_name}`}
                                        key={``}
                                    >
                                        <div className="watches-subcats__item-img-box">
                                            <img
                                                className="watches-subcats__item-img"
                                                src={cat.file ? cat.file.urls.orig : IMG_PLACEHOLDER_PRODUCT}
                                                alt={cat.name}
                                            />
                                        </div>

                                        <h3 className="watches-subcats__item-name">
                                            {cat.name} ({cat.published_count})
                                        </h3>
                                    </Link>
                                ))}
                        </div>
                        : null
                    :
                    <div className="catalog__categories-preloader">
                        <MiniPreloader />
                    </div>
                }


        </div>
    );
}

export default WatchesSubcats